import { netsparkAxios } from 'core/services/HTTPService';
import { IInsideSalesDataItem } from '@dashboardWirelineInsideSalesDepartment/InsideSalesBookingList/InsideSalesBookingList.models';
import { insideSalesBookingUrl } from 'pages/Dashboard/api/apiUrls';
import { IRequestPaging } from 'core/services/HTTPService.models';

const getInsideSalesBookingData = (signal: AbortSignal, params: object) => netsparkAxios
  .get<IRequestPaging<IInsideSalesDataItem[]>>(insideSalesBookingUrl, { signal, params });

export default getInsideSalesBookingData;
